import { render } from "./CoReg_Companies.vue?vue&type=template&id=41e9de69&scoped=true"
import script from "./CoReg_Companies.vue?vue&type=script&lang=js"
export * from "./CoReg_Companies.vue?vue&type=script&lang=js"

import "./CoReg_Companies.vue?vue&type=style&index=0&id=41e9de69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e9de69"]])

export default __exports__